import React, { useCallback, useState } from "react";
import { StoreyMeasurementContext, StoreyMeasurementContextProps } from "./storey-measurement-context-props.ts";
import useModelingToolsContext from "@/services/context/viewer/modeling-tools/use-modeling-tools-context.ts";

const StoreyMeasurementProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { setIsInDrawingMode } = useModelingToolsContext();
    const [isMeasurementToolOpen, setIsMeasurementToolOpen] = useState(false);
    const [measuredLines, setMeasuredLines] = useState<number[]>([]);

    const addMeasuredLine = useCallback((val: number) => {
        setMeasuredLines(prev => [...prev, val]);
    }, []);

    const clearMeasuredLines = useCallback(() => {
        setMeasuredLines([]);
    }, []);

    const closeMeasurementTool = useCallback(() => {
        setIsMeasurementToolOpen(false);
        setMeasuredLines([]);
    }, []);

    const openMeasurementTool = useCallback(() => {
        setIsInDrawingMode(false);
        setIsMeasurementToolOpen(true);
        setMeasuredLines([]);
    }, [setIsInDrawingMode]);

    const toggleMeasurementTool = useCallback((open?: boolean) => {
        const nextState = open !== undefined ? open : !isMeasurementToolOpen;
        if (nextState) {
            openMeasurementTool();
        } else {
            closeMeasurementTool();
        }
    }, [isMeasurementToolOpen, openMeasurementTool, closeMeasurementTool]);

    const contextProps: StoreyMeasurementContextProps = {
        isMeasurementToolOpen,
        measuredLines,
        openMeasurementTool,
        closeMeasurementTool,
        toggleMeasurementTool,
        addMeasuredLine,
        clearMeasuredLines
    };

    return (
        <StoreyMeasurementContext.Provider value={contextProps}>
            {children}
        </StoreyMeasurementContext.Provider>
    );
};

export default StoreyMeasurementProvider;
